import {
	OPEN_CONTEXT_PANEL,
	HIDE_CONTEXT_PANEL,
	ADD_STEP_TO_CONTEXT,
	REMOVE_STEP_FROM_CONTEXT,
	ADD_CONTEXT_VARIABLE,
	DELETE_CONTEXT_VARIABLE,
	UPDATE_CONTEXT_VARIABLE,
	SET_CONTEXT_VARIABLES,
	SET_CONTEXT,
	UPDATE_STEP_CONTEXT_OUTPUT_DATA,
	SET_CONTEXT_CREDENTIALS_MANAGEMENT,
	ADD_CONTEXT_TRIGGER,
	DELETE_CONTEXT_TRIGGER,
	UPDATE_CONTEXT_TRIGGER,
	TOGGLE_CONTEXT_TRIGGER,
	SET_CONTEXT_FILTER_OPTIONS,
	CHANGE_CONTEXT_FILTER_OPTION
} from "redux/constants/flowDesigner";

export const setContext = (payload) => ({
	type: SET_CONTEXT,
	payload
});

export const openContextPanel = () => ({
	type: OPEN_CONTEXT_PANEL
});
export const hideContextPanel = () => ({
	type: HIDE_CONTEXT_PANEL
});
export const addStepToContext = (componentKey, data, flowName) => ({
	type: ADD_STEP_TO_CONTEXT,
	payload: { componentKey, data, flowName }
});
export const updateStepContextOutputData = (componentKey, data, flowName) => ({
	type: UPDATE_STEP_CONTEXT_OUTPUT_DATA,
	payload: { componentKey, data, flowName }
});
export const removeStepFromContext = (componentKey, flowName) => ({
	type: REMOVE_STEP_FROM_CONTEXT,
	payload: { componentKey, flowName }
});
export const addContextVariable = (componentKey, flowName) => ({
	type: ADD_CONTEXT_VARIABLE,
	payload: { componentKey, flowName }
});
export const deleteContextVariable = (componentKey, flowName) => ({
	type: DELETE_CONTEXT_VARIABLE,
	payload: { componentKey, flowName }
});
export const updateContextVariable = (id, data, flowName) => ({
	type: UPDATE_CONTEXT_VARIABLE,
	payload: { id, data, flowName }
});
export const setContextVariables = (variables, flowName) => ({
	type: SET_CONTEXT_VARIABLES,
	payload: { variables, flowName }
});
export const setContextCredentialsManagement = (payload) => ({
	type: SET_CONTEXT_CREDENTIALS_MANAGEMENT,
	payload
});
export const addContextTrigger = (triggerName, flowName) => ({
	type: ADD_CONTEXT_TRIGGER,
	payload: { triggerName, flowName }
});
export const deleteContextTrigger = (triggerName, flowName) => ({
	type: DELETE_CONTEXT_TRIGGER,
	payload: { triggerName, flowName }
});
export const updateContextTrigger = (triggerName, flowName, data) => ({
	type: UPDATE_CONTEXT_TRIGGER,
	payload: { triggerName, flowName, data }
});
export const toggleContextTrigger = (triggerName, flowName) => ({
	type: TOGGLE_CONTEXT_TRIGGER,
	payload: { triggerName, flowName }
});
export const setContextFilterOptions = (payload) => ({
	type: SET_CONTEXT_FILTER_OPTIONS,
	payload
});
export const changeContextFilterOption = (payload) => ({
	type: CHANGE_CONTEXT_FILTER_OPTION,
	payload
});
